import { useSelector, useDispatch } from "react-redux";

import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";

import { dataExplorerActions } from "../../store";
import { entities } from "../../config/config.dataExplorer";
import { Typography } from "@mui/material";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function Filter({ id }) {
  const dispatch = useDispatch();
  const selectedEntity = useSelector(
    (state) => state.dataExplorer.selectedEntity
  );

  const filterValues = useSelector((state) =>
    state.dataExplorer.filters[selectedEntity][id]
      ? state.dataExplorer.filters[selectedEntity][id]
      : []
  );

  const data = useSelector((state) => state.data[selectedEntity]?.data);
  const entity = entities[selectedEntity];
  const filterConfig = entity?.filterOptions?.find(
    (filter) => filter.id === id
  );

  let filterValueOptions = [];
  const dataFirstItem = data?.[0] || {};
  if (Object.keys(dataFirstItem).includes(id)) {
    filterValueOptions = [
      ...new Set(
        data
          ?.map((dataItem) => dataItem[id])
          .filter((option) => option)
          .map((option) => {
            if (typeof option === "string") {
              return option.split(/[,;]+/);
            } else if (Object.keys(option).includes("name")) {
              return option.name.split(/[,;]+/);
            }
            return "";
          })
          ?.flat()
          // trim whitespace and remove empty strings
          ?.map((option) => option?.trim())
          ?.filter((option) => option)
      ),
    ];
  }

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    // On autofill we get a stringified value.
    const newValue = typeof value === "string" ? value.split(",") : value;
    dispatch(
      dataExplorerActions.setFilter({ id, value: newValue, selectedEntity })
    );
  };

  return (
    <FormControl sx={{ width: 150 }} size="small">
      <InputLabel
        id={`multiple-checkbox-inputLabel-${id}`}
        sx={{
          fontSize: "0.8rem",
          color: "primary.contrastText",
          lineHeight: filterValues.length > 0 ? "" : "1em",
          // set color on focus
          "&.Mui-focused": { color: "primary.contrastText" },
        }}
      >
        {filterConfig.label}
      </InputLabel>
      <Select
        labelId={`multiple-checkbox-label-${id}`}
        id={`multiple-checkbox-${id}`}
        multiple={filterConfig.multiple}
        value={filterConfig.multiple ? filterValues : filterValues[0] || ""}
        onChange={handleChange}
        input={
          <OutlinedInput
            label={filterConfig.label}
            sx={{
              fontSize: "0.8rem",
              height: "30px",
              borderRadius: "15px",

              "& .MuiInputBase-root": {
                "&:focus": {
                  borderColor: "#000",
                },
              },
            }}
          />
        }
        renderValue={(selected) =>
          Array.isArray(selected) ? selected.join(", ") : selected
        }
        MenuProps={MenuProps}
      >
        {filterValueOptions
          .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
          .map((id) => (
            <MenuItem key={id} value={id}>
              <Checkbox
                checked={filterValues.indexOf(id) > -1}
                size="small"
                sx={{ "&.Mui-checked": { color: "secondary.main" } }}
              />
              <ListItemText
                primary={
                  <Typography
                    sx={{
                      fontSize: "0.9rem",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {id}
                  </Typography>
                }
              />
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}
